import { StyleSheet, Platform } from 'react-native';
import { FontFamily } from '../../constants/fonts';
import { AdminColors } from '../Admin/constants/adminColors';

export const styles = StyleSheet.create({
  // ── Root layout ───────────────────────────────────────────────────────────
  root: { flex: 1, backgroundColor: AdminColors.bgPage },
  scrollRoot: { flex: 1 },
  scrollContent: { padding: 24, paddingBottom: 80, gap: 20 },

  // ── Loading wrap ──────────────────────────────────────────────────────────
  loadingWrap: { flex: 1, alignItems: 'center', justifyContent: 'center' },

  // ── Breadcrumb ────────────────────────────────────────────────────────────
  breadcrumb: { flexDirection: 'row', alignItems: 'center', flexWrap: 'wrap', gap: 2, marginBottom: 4 },
  bcLink: { fontSize: 14, color: AdminColors.blue700, fontFamily: FontFamily.regular },
  bcSep: { fontSize: 14, color: '#BDBDBD', marginHorizontal: 2 },
  bcCurrent: { fontSize: 14, color: '#1A1A1A', fontWeight: '500', fontFamily: FontFamily.medium },

  // ── Page title ────────────────────────────────────────────────────────────
  pageTitle: { fontSize: 28, fontWeight: '700', color: '#1A1A1A', fontFamily: FontFamily.bold },

  // ── Info box (read-only route info) ──────────────────────────────────────
  infoBox: {
    backgroundColor: AdminColors.blue25, borderWidth: 1, borderColor: AdminColors.blue75,
    borderRadius: 8, padding: 20, position: 'relative',
  },
  roLabel: {
    position: 'absolute', top: 10, right: 12,
    backgroundColor: AdminColors.blue75, borderRadius: 4,
    paddingHorizontal: 7, paddingVertical: 2,
  },
  roText: {
    fontSize: 10, fontWeight: '700', letterSpacing: 0.6,
    color: AdminColors.blue800, textTransform: 'uppercase', fontFamily: FontFamily.bold,
  },
  infoGrid: { flexDirection: 'row', flexWrap: 'wrap', gap: 16, marginTop: 4 },
  infoField: { flexDirection: 'column', gap: 2, minWidth: 120 },
  infoKey: {
    fontSize: 11, fontWeight: '700', textTransform: 'uppercase',
    letterSpacing: 0.5, color: AdminColors.gray450, fontFamily: FontFamily.bold,
  },
  infoVal: { fontSize: 15, fontWeight: '600', color: '#1A1A1A', fontFamily: FontFamily.medium },

  // ── Card ──────────────────────────────────────────────────────────────────
  card: {
    backgroundColor: '#fff', borderRadius: 8, padding: 24,
    ...Platform.select({
      ios: { shadowColor: '#000', shadowOffset: { width: 0, height: 1 }, shadowOpacity: 0.06, shadowRadius: 4 },
      android: { elevation: 1 },
    }),
  },
  cardTitle: { fontSize: 18, fontWeight: '700', color: '#1A1A1A', fontFamily: FontFamily.bold, marginBottom: 4 },
  cardSub: { fontSize: 13, color: AdminColors.gray450, fontFamily: FontFamily.regular, marginBottom: 16 },

  // ── Reason code grid ──────────────────────────────────────────────────────
  rcGrid: { flexDirection: 'row', flexWrap: 'wrap', gap: 12 },
  rcTile: {
    position: 'relative', backgroundColor: '#fff',
    borderWidth: 1.5, borderColor: AdminColors.gray50,
    borderRadius: 10, paddingVertical: 16, paddingHorizontal: 16,
    minHeight: 120,
    flexDirection: 'column', gap: 10,
  },
  rcTileSel: {
    borderWidth: 2, borderColor: AdminColors.blue700,
    backgroundColor: AdminColors.blue25, paddingVertical: 15, paddingHorizontal: 15,
  },
  rcCheck: {
    position: 'absolute', top: 8, right: 8,
    width: 20, height: 20, borderRadius: 10,
    backgroundColor: AdminColors.blue700,
    alignItems: 'center', justifyContent: 'center',
  },
  rcReasonRow: { flexDirection: 'row', alignItems: 'center', gap: 8, paddingRight: 18 },
  rcReasonIconWrap: {
    width: 20,
    height: 20,
    alignItems: 'center',
    justifyContent: 'center',
  },
  rcEmojiIcon: { fontSize: 17, lineHeight: 20 },
  rcLabel: { fontSize: 13, fontWeight: '600', color: '#1A1A1A', fontFamily: FontFamily.medium, lineHeight: 18 },

  // ── Empty text ────────────────────────────────────────────────────────────
  emptyText: { fontSize: 14, color: AdminColors.textMuted, fontFamily: FontFamily.regular, paddingVertical: 8 },

  // ── Missing Equipment sub-section ─────────────────────────────────────────
  eqSection: { marginTop: 24, paddingTop: 20, borderTopWidth: 1, borderTopColor: AdminColors.gray25, gap: 12 },
  eqSectionHeader: { flexDirection: 'row', alignItems: 'center', gap: 8 },
  eqSectionTitle: { fontSize: 16, fontWeight: '700', color: '#1A1A1A', fontFamily: FontFamily.bold },
  eqSectionSub: { fontSize: 12, color: AdminColors.textMuted, fontFamily: FontFamily.regular, lineHeight: 18 },
  eqGrid: { flexDirection: 'row', flexWrap: 'wrap', gap: 10, marginTop: 4 },
  eqChk: {
    flexDirection: 'row', alignItems: 'center', gap: 10,
    borderWidth: 1.5, borderColor: AdminColors.gray50,
    borderRadius: 8, paddingVertical: 11, paddingHorizontal: 14,
    backgroundColor: '#fff', width: '47%', minWidth: 160,
  },
  eqChkSel: { borderColor: AdminColors.blue700, backgroundColor: AdminColors.blue25 },
  eqBox: {
    width: 17, height: 17, borderWidth: 1.5,
    borderColor: AdminColors.gray300, borderRadius: 3,
    alignItems: 'center', justifyContent: 'center', backgroundColor: '#fff',
  },
  eqBoxSel: { backgroundColor: AdminColors.blue700, borderColor: AdminColors.blue700 },
  eqLabel: { fontSize: 14, fontWeight: '500', color: '#1A1A1A', fontFamily: FontFamily.medium, flex: 1 },

  // ── Additional details ────────────────────────────────────────────────────
  textArea: {
    minHeight: 96, paddingHorizontal: 12, paddingVertical: 10,
    borderWidth: 1, borderColor: AdminColors.borderDefault, borderRadius: 6,
    fontSize: 14, color: '#1A1A1A', backgroundColor: '#fff', fontFamily: FontFamily.regular,
  },
  charCounter: {
    fontSize: 12, color: AdminColors.textMuted, fontWeight: '500',
    fontFamily: FontFamily.medium, marginTop: 6, textAlign: 'right',
  },
  charCounterWarn: { color: AdminColors.textError, fontWeight: '700' },
  textAreaError: { borderColor: AdminColors.red500 },

  // ── Required asterisk ─────────────────────────────────────────────────────
  requiredAsterisk: { color: AdminColors.red500, fontWeight: '700' },

  // ── Error text ────────────────────────────────────────────────────────────
  errorText: { fontSize: 12, color: AdminColors.red500, fontWeight: '500', fontFamily: FontFamily.medium, marginTop: 8 },

  // ── Form actions ──────────────────────────────────────────────────────────
  formActions: { flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', paddingTop: 4 },
  cancelBtn: {
    height: 40, paddingHorizontal: 24, borderRadius: 24,
    borderWidth: 1, borderColor: AdminColors.blue800,
    alignItems: 'center', justifyContent: 'center',
  },
  cancelBtnText: { fontSize: 16, fontWeight: '700', color: AdminColors.blue800, fontFamily: FontFamily.bold },
  submitBtn: {
    height: 40, paddingHorizontal: 24, borderRadius: 24,
    backgroundColor: AdminColors.blue800,
    alignItems: 'center', justifyContent: 'center',
  },
  submitBtnDisabled: { backgroundColor: AdminColors.gray50 },
  submitBtnText: { fontSize: 16, fontWeight: '700', color: '#fff', fontFamily: FontFamily.bold },
  submitBtnTextDisabled: { color: AdminColors.gray300 },

  // ── Error banner (full-screen guard states) ───────────────────────────────
  errorBanner: {
    flexDirection: 'row', alignItems: 'center', gap: 10,
    backgroundColor: AdminColors.red75, borderWidth: 1, borderColor: AdminColors.red500,
    borderRadius: 8, padding: 14, margin: 24, flexWrap: 'wrap',
  },
  errorBannerText: { flex: 1, fontSize: 14, color: AdminColors.red700, fontFamily: FontFamily.regular },
  returnLink: { fontSize: 14, fontWeight: '700', color: AdminColors.blue800, fontFamily: FontFamily.bold },

  // ── Submit error banner ───────────────────────────────────────────────────
  submitErrorBanner: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: 10,
    backgroundColor: AdminColors.yellow50,
    borderWidth: 1,
    borderColor: AdminColors.yellow200,
    borderRadius: 8,
    padding: 12,
  },
  submitErrorBannerText: {
    flex: 1,
    fontSize: 14,
    lineHeight: 20,
    color: '#6b4a05',
    fontFamily: FontFamily.regular,
  },

  // ── Modal ─────────────────────────────────────────────────────────────────
  modalOverlay: {
    flex: 1, backgroundColor: 'rgba(0,0,0,0.50)',
    alignItems: 'center', justifyContent: 'center', padding: 24,
  },
  modalCard: {
    backgroundColor: '#fff', borderRadius: 12, padding: 28,
    width: '100%', maxWidth: 400, alignItems: 'center', gap: 12,
    ...Platform.select({
      ios: { shadowColor: '#000', shadowOffset: { width: 0, height: 4 }, shadowOpacity: 0.18, shadowRadius: 16 },
      android: { elevation: 8 },
    }),
  },
  modalTitle: { fontSize: 20, fontWeight: '700', color: '#1A1A1A', fontFamily: FontFamily.bold, textAlign: 'center' },
  modalBody: { fontSize: 15, color: AdminColors.gray450, fontFamily: FontFamily.regular, textAlign: 'center', lineHeight: 22 },
  modalBtn: {
    height: 42, paddingHorizontal: 32, borderRadius: 24,
    backgroundColor: AdminColors.blue800, alignItems: 'center', justifyContent: 'center',
  },
  modalBtnText: { fontSize: 15, fontWeight: '700', color: '#fff', fontFamily: FontFamily.bold },
  modalActions: { flexDirection: 'row', gap: 12, marginTop: 8, justifyContent: 'center', alignItems: 'center' },
  modalSecondaryBtn: {
    height: 42, paddingHorizontal: 28, borderRadius: 24,
    borderWidth: 1, borderColor: AdminColors.blue800,
    alignItems: 'center', justifyContent: 'center',
  },
  modalSecondaryBtnText: { fontSize: 15, fontWeight: '700', color: AdminColors.blue800, fontFamily: FontFamily.bold },

  // ── Toast ─────────────────────────────────────────────────────────────────
  toastWrap: {
    position: 'absolute', top: 16, left: 20, right: 20,
    alignItems: 'center', zIndex: 700,
  },
  toast: {
    flexDirection: 'row', alignItems: 'center', gap: 12,
    paddingVertical: 12, paddingHorizontal: 18,
    backgroundColor: '#fff', borderRadius: 8,
    borderLeftWidth: 4, borderLeftColor: AdminColors.green600,
    ...Platform.select({
      ios: { shadowColor: '#005EBC', shadowOffset: { width: 0, height: 2 }, shadowOpacity: 0.12, shadowRadius: 24 },
      android: { elevation: 6 },
    }),
    minWidth: 260,
  },
  toastText: { fontSize: 14, fontWeight: '600', color: '#1A1A1A', fontFamily: FontFamily.medium, flex: 1 },
});
